import { useCallback, useEffect, useState } from 'react';
import { api } from './api';

// Loads JSON from `url` (skipped when url is null). Returns { data, error, loading, reload }.
export function useFetch(url) {
  const [state, setState] = useState({ data: null, error: null, loading: !!url });
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!url) return undefined;
    let alive = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    api(url)
      .then((data) => alive && setState({ data, error: null, loading: false }))
      .catch((error) => alive && setState({ data: null, error, loading: false }));
    return () => { alive = false; };
  }, [url, tick]);
  const reload = useCallback(() => setTick((t) => t + 1), []);
  return { ...state, reload };
}
